// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-logo[data-v-2f4c92ae]{position:absolute;top:20px;left:20px}", ""]);
// Exports
module.exports = exports;
